<script setup lang="ts">
import IOHeroContentMenuBuffer from "@/components/io/io-hero/content/IOHeroContentMenuBuffer.vue";
// ⚠️ Could not locate Tag.vue
// import Tag from 'primevue/tag'

const props = withDefaults(defineProps<{
  id: string,
  w?: string,
  content: Record<string, any>
}>(), {
  id: '',
  w: 'w-full max-w-92% mx-auto grid grid-cols-[1fr] ds:grid-cols-[2fr_1fr] g-1 gpb-4 gpt-3',
  content: () => {
    return {
      hairline: '',
      title: '',
      description: '',
      line: false,
      lineColor: 'white',
    }
  }
})

const content = computed(() => props.content)

const hairline = computed(() => content.value.hairline)
const title = computed(() => content.value.title)
const description = computed(() => content.value.description)
const line = computed(() => content.value.line)
const lineColor = computed(() => content.value.lineColor)
const tags = computed(() => content.value?.tags || [])
</script>

<template>
  <div class="io-hero-content hero-slide content-product" :class="id">

    <IOHeroContentMenuBuffer :id="id" />
    
    <div class="content-container" :class="w">
      <Column class="col-content" w="grid g-0.75">
        <!-- <div v-if="tags.length > 0" class="io-h-tags">
          <Tag class="tag" v-for="tag in tags" :key="tag">
            {{ tag }}
          </Tag>
        </div> -->
        
        <div class="io-h-hairline" v-if="hairline" v-html="hairline" />
        <div class="io-h-primary-title" v-html="title" />
        <!-- <div class="io-h-line" v-if="line">
          <div class="line" :style="{ backgroundColor: lineColor }" />
        </div> -->
        
        

        <div class="io-h-description" v-if="description" v-html="description" />

        <!-- I now just need to figure out how how to set the height of this to auto, with a prefended min height baed on the page in question, and if the content proceeds further it transitions the auto height accordingly, -->

      </Column>

      <Column class="col-space hidden ds:block">


      </Column>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.io-hero-content {

  display: flex;
  align-items: center;
  justify-content: flex-end;

  .io-content-menu-buffer {

  }

  .content-container {
    width: 100%;

    .col-content {

      .io-h-hairline {
        font-size: fs(-0.5);
        color: white;
        @apply tracking-widest;
      }

      .io-h-primary-title {
        font-size: fs(5.5);
        color: white;
        font-weight: 400;
        line-height: gr(2.25);

        // font-family: var(--kodchasan);
      }

      .io-h-line {
        .line {
          width: 100px;
          height: 1px;
          background-color: white;
        }
      }

      .io-h-description {
        font-size: fs(0.5);

        color: white;
      }
    }
  }




}
</style>
